(function () {
  function initOne(root) {
    if (root.dataset.revInit) return;
    root.dataset.revInit = '1';
    var grid = root.querySelector('.herev__grid');
    if (!grid) return;
    var prev = root.querySelector('.herev__nav--prev');
    var next = root.querySelector('.herev__nav--next');
    function step() {
      var card = grid.querySelector('.herev__card');
      var gap = parseInt(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap || '16', 10) || 16;
      return card ? card.getBoundingClientRect().width + gap : Math.round(grid.clientWidth * 0.85);
    }
    if (prev) prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  function initAll() {
    var nodes = document.querySelectorAll('.herev');
    for (var i = 0; i < nodes.length; i++) { initOne(nodes[i]); }
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
